<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>训练数据</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Loginname" label="登录名称" min-width="8%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="6%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="8%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="8%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="8%"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构" min-width="16%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="4%"></el-table-column>
          <el-table-column prop="Righteyedegree" label="右眼度数" min-width="5%"></el-table-column>
          <el-table-column prop="Lefteyedegree" label="左眼度数" min-width="5%"></el-table-column>
          <el-table-column prop="Currangeup" label="当前训练区间上限" min-width="6%"></el-table-column>
          <el-table-column prop="Currangelow" label="当前训练区间下限" min-width="6%"></el-table-column>
          <el-table-column prop="Curnum" label="当前训练次数" min-width="4%"></el-table-column>
          <el-table-column prop="Curspeed" label="当前训练速度" min-width="4%"></el-table-column>
          <el-table-column prop="Rengongstates" label="是否激活人工训练" min-width="4%"></el-table-column>
          <el-table-column prop="Dzstates" label="定制状态" min-width="4%"></el-table-column>
          <el-table-column prop="Diopterstates" label="屈光状态" min-width="8%"></el-table-column>
          <el-table-column label="操作" min-width="4%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <TrainingDataChange ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></TrainingDataChange>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TrainingDataChange from '@/componentsSubVue/TrainingDataChange.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TrainingDataChange
  },
  name: 'MyTrainingData',
  data () {
    return {
      loading: false,
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        name: '',
        phone: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        saletype: '0'
      }
    }
  },
  mounted () {
    this.apigetcustomernum2()
    this.apigetcustomerlist2()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetcustomerlist2()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetcustomernum2()
      this.apigetcustomerlist2()
    },
    clickmodify (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: 'TrainingDataChange', params: { userid: row.Id } })
    },
    apigetcustomerlist2: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerlist2, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetcustomernum2: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomernum2, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
